import { useCallback } from 'react';
import { useCustomMutation } from './core/useCustomMutation';
import { generateFirstHomeworkHelp } from '../../services/api/wr-tools/generateFirstHomeworkHelp';
import { useAuthContext } from '../auth/useAuthContext';
import { useEditorContext } from '../editor/useEditorContext';
import { getCookie } from '../../utilities/helpers/cookie';
import { CookieName } from '../../utilities/constants/common';
import { getSourceUrl } from '../../utilities/helpers/common';
import { getRequestType } from '../../utilities/helpers/editor';

export const useGenerateFirstHomeworkHelp = () => {
  const {
    userHomeworkHelpRequest,
    userHomeworkHelpSubject,
    userHomeworkHelpTextFromFiles,
    EditorActionCreator,
    editorDispatch,
  } = useEditorContext();
  const {
    userId,
    clientHash,
    isUserSubscribed,
    freePremiumGenerationsAttemptsCount,
  } = useAuthContext();

  const { error, isLoading, isSuccess, mutateAsync } = useCustomMutation(
    generateFirstHomeworkHelp,
    {
      onSuccess: (response) => {
        if (response?.data) {
          editorDispatch(
            EditorActionCreator.setGenerationText(
              response.data.generatedText || ''
            )
          );
          editorDispatch(
            EditorActionCreator.setGenerationId(
              response.data.responseGenIdHash || ''
            )
          );
          editorDispatch(
            EditorActionCreator.setGenerationChatId(
              response.data.chatIdHash || ''
            )
          );
          editorDispatch(
            EditorActionCreator.setGenerationSubjectGroup(
              response.data.textSubjectGroup || ''
            )
          );
        }
      },
      retry: 2,
    }
  );

  const generateFirstHomeworkHelpMutation = useCallback(
    () =>
      mutateAsync({
        clientHash,
        clientUserId: userId,
        sessionSourceUrl: getSourceUrl(),
        gaCid: getCookie(CookieName.GA) || '',
        requestType: getRequestType(
          isUserSubscribed,
          freePremiumGenerationsAttemptsCount
        ),
        subject: userHomeworkHelpSubject,
        instructions: userHomeworkHelpRequest,
        instructionsFromFiles: userHomeworkHelpTextFromFiles,
      }),
    [
      clientHash,
      userHomeworkHelpRequest,
      userHomeworkHelpTextFromFiles,
      userHomeworkHelpSubject,
      userId,
      isUserSubscribed,
      freePremiumGenerationsAttemptsCount,
      mutateAsync,
    ]
  );

  return {
    error,
    isTextGenerating: isLoading,
    isTextGenerationSuccess: isSuccess,
    generateFirstHomeworkHelpMutation,
  };
};
